import React, { useEffect, useRef } from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";
import { createScheduler, createWorker } from "tesseract.js";

import useCreditCardEntryState from "../state";

const scheduler = createScheduler();

export default function VideoTextRecognition({ setData }) {
  const videoRef = useRef();
  const streamRef = useRef();

  const [, dispatch] = useCreditCardEntryState();

  const setHasStream = () => dispatch({ type: "OCR Has Stream" });

  useEffect(() => {
    if (videoRef && videoRef.current) {
      navigator.mediaDevices
        .getUserMedia({
          video: { facingMode: "environment" },
          audio: false,
        })
        .then((stream) => {
          setHasStream(true);
          videoRef.current.srcObject = stream;

          (async () => {
            const worker = createWorker();
            await worker.load();
            await worker.loadLanguage("eng");
            await worker.initialize("eng");
            await worker.setParameters({
              tessedit_char_whitelist: "0123456789/ ",
            });
            scheduler.addWorker(worker);
            requestAnimationFrame(doOCR);
          })();

          videoRef.current.play();
          streamRef.current = stream;
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    }

    return () => {
      streamRef &&
        streamRef.current &&
        streamRef.current.getTracks().forEach((track) => track.stop());
    };
  }, []);

  const doOCR = async () => {
    if (videoRef && videoRef.current) {
      const canvas = document.createElement("canvas");

      const { width, height } = videoRef.current.srcObject
        .getVideoTracks()[0]
        .getSettings();
      canvas.width = width;
      canvas.height = height;
      canvas.getContext("2d").drawImage(videoRef.current, 0, 0, width, height);

      const { data } = await scheduler.addJob("recognize", canvas);

      setData(data);
      requestAnimationFrame(doOCR);
    }
  };

  return (
    <Wrapper>
      <Video autoPlay muted playsInline ref={videoRef} width="100%" />
      <Indicator />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  overflow: hidden;
`;

const Video = styled(motion.video)`
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
`;

const Indicator = styled.div`
  border: 4px solid #278dc1;
  width: 80%;
  height: 60px;
  z-index: 2;
  border-radius: 12px;
  box-shadow: rgba(0, 0, 0, 1) 0 0 80px;
`;
